import styled from 'styled-components'

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};

  :first-child {
    display: block;
  }
`
